export const MAX_RECENT_ENTRIES_COUNT = 5;

export enum ItemResultType {
  ExternalLocation = 'external_location',
  Location = 'location',
  PostalArea = 'postal_area',
  PostalReference = 'postal_reference',
  Treatments = 'treatments',
  TreatmentType = 'treatmentType',
  Venue = 'venue',
  CurrentLocation = 'current-location',
  BoundedBox = 'box',
  VenueType = 'venueType',
}

export interface ItemResultData {
  name: string;
  entityType: ItemResultType;
  entityValue: string;
  aliasId?: number;
  entityId?: string;
}

export interface ItemResult {
  key: string;
  data: ItemResultData;
  label: string;
  labelRight?: string;
  url?: string;
  type: ItemResultType;
}

export function makeItemResult({
  entity: { entityType, entityValue, name, entityId, aliasId },
  section,
  displayRight,
}: {
  entity: ItemResultData;
  section?: 'popular' | 'recent' | 'filter' | 'search';
  displayRight?: string;
}): ItemResult {
  return {
    key: `${section ?? ''}:${entityType}:${entityValue}`,
    data: { name, entityId, entityType, entityValue, aliasId },
    label: name,
    labelRight: displayRight,
    type: entityType,
  };
}

export function isItemResultType(
  candidate: string
): candidate is ItemResultType {
  return (Object.values(ItemResultType) as string[]).includes(candidate);
}
